@if (counter$() | async; as counter) {
  @if (counter > 0) {
    <p-badge
      [value]="counter.toString()"
      severity="danger" />
  }
}
